import React, { useState } from "react";
import "./HelloSuperStarShakib.css";
import helloShakibPagePhoto from "../../../../../assets/images/Group 227.png";
import CongratulationModal from "./CongratulationModal/CongratulationModal";
import { useEffect } from "react";
import axios from "axios";
import { Markup } from "interweave";
import { useContext } from "react";
import { serverInfo } from "../../../../../App";

const HelloSuperStarShakib = () => {
  const [modalShow, setModalShow] = useState(false);

  const [starInfo, setStarInfo] = useState();
  const { imageCdnUrl } = useContext(serverInfo);

  useEffect(() => {
    axios.get(`api/getStarInfo/data/${localStorage.auth_id}`).then((res) => {
      setStarInfo(res.data?.starInfo);
    });
  }, []);

  return (
    <div className="helloShakib">
      <div className="d-flex justify-content-center align-items-center">
        <div className="helloShakib-border">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-6 d-flex align-items-center">
                <div>
                  <div className="mb-4">
                    <h2 className="text-warning fw-bold">Hello...!</h2>
                    <h1 className="superStarName">{localStorage.auth_name}</h1>
                  </div>
                  <h4 className="text-warning ">Terms and Conditions</h4>
                  <div className="d-flex p-text">
                    <Markup content={starInfo?.terms_and_condition} />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="secondCol">
                  <img
                    className="img-fluid"
                    src={helloShakibPagePhoto}
                    alt=""
                  />
                  <img
                    src={
                      starInfo?.super_star?.image
                        ? imageCdnUrl + starInfo?.super_star?.image
                        : helloShakibPagePhoto
                    }
                    alt=""
                    className="img-star-pro"
                  />
                </div>
                <div className="d-flex justify-content-center mt-5">
                  {/* <button type="button" className="btn btn-secondary w-25 me-3">
                    Edit
                  </button> */}

                  <button
                    onClick={() => setModalShow(true)}
                    type="button"
                    className="btn btnCreate w-25 ms-3"
                  >
                    Next
                  </button>

                  <CongratulationModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelloSuperStarShakib;
